import { render, staticRenderFns } from "./SlidesPanel.vue?vue&type=template&id=61be574a&scoped=true"
import script from "./SlidesPanel.vue?vue&type=script&lang=js"
export * from "./SlidesPanel.vue?vue&type=script&lang=js"
import style0 from "./SlidesPanel.vue?vue&type=style&index=0&id=61be574a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be574a",
  null
  
)

export default component.exports